export default (
  { graphQLErrors, networkError, operation, forward },
  nuxtContext
) => {
  console.log('Error handler', graphQLErrors, networkError, operation, forward)
}
